import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { OrgBranchStateManagement } from 'src/app/store/branch/reducer';
declare const Swal;

@Component({
  selector: 'g10-roster-dashboard-request',
  templateUrl: './roster-dashboard-request.component.html',
  styleUrls: ['./roster-dashboard-request.component.css']
})
export class RosterDashboardRequestComponent implements OnInit {

  public successData: any;
  public matFormSize: string = '13px';
  public setTodayDate: any = new Date();
  public cols: any = []
  public unAssignedCols: any = [
    { key: '#', display: '#' },
    {
      key: 'empRefID', display: 'Employee ID',
      config: {
        isUppercase: true,
      }
    },
    {
      key: 'empName', display: 'Employee Name',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    },
    { key: 'gender', display: 'Gender' },
    { key: 'shiftTime', display: 'Shift Time' },
    {
      key: 'eta', display: 'ETA',
      headerConfig: { isUppercase: true },
    },
    {
      key: 'address', display: 'Address',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    },
  ]
  public assignCols: any = [
    { key: '#', display: '#' },
    {
      key: 'empRefID', display: 'Employee ID',
      config: {
        isUppercase: true,
      }
    },
    {
      key: 'empName', display: 'Employee Name',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    },
    { key: 'gender', display: 'Gender' },
    {
      key: 'driverName', display: 'Driver Name', config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    },
    {
      key: 'vehRegNo', display: 'Vehicle Reg No',
      config: {
        isVehicle: true,
      }
    },
    { key: 'shiftTime', display: 'Shift Time' },
    {
      key: 'eta', display: 'ETA',
      headerConfig: { isUppercase: true },
    },
    {
      key: 'address', display: 'Address',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 20,
          concatVal: '...',
        }
      }
    }

  ]
  public tableData: any = []
  public noDataFoundEnable: boolean = false;
  public showTable: boolean = true;
  public isEmpTable: boolean = false;
  public listOfEmpolyers: any = '';
  public currentDate: boolean = true;
  public formSubmitted: boolean = false;
  // Form variables
  public uploadForm: FormGroup;
  public filterFormGrp: FormGroup;
  public formSubmit: boolean = false;
  public loginFormData: any = {};
  public filterFormData: any = {}
  public errorMsg: any = '';
  public fileValid: boolean = false;
  public listWiseDropdown: boolean = false;
  public filteredObj: any = {};
  public vehObjList: any = {};
  public empsLoader: boolean = false;
  // Error Variable
  public errMsg: any = {};
  public showErrMsg: any = '';
  // excelVariables
  public xlFileName: any = ''
  public excelData = {};
  public showDownloadBtn: boolean = false;
  public activeUpload: any = {
    text: '',
    transitMode: '',
  }
  public successDataLen: any = 0;
  public errDataLen: any = 0;
  public totlErrs: any = '';
  public fatErr: boolean = false;
  public loginRouteID: string = '';
  public logoutRouteID: string = '';
  public getRow: any = '';
  public getNameOfErr: any = '';
  public successEmpId: any = ''
  public checkBoxValue: Boolean = false;
  public checkBoxShow: boolean = false;
  public getUploadedType: any = 'singleDay';
  public setMinDate = new Date();
  public maxEndDate = new Date();
  public errorObject: any = {};
  public checkedDatas: any = [];
  public disableBtn: boolean = true;
  public getvehicles: any = [];
  public shiftInformation: any = [];
  public dateLoader:boolean = true;

  constructor(
    public swal: SweetAlert,
    private api: ApiService,
    public storage: StorageService,
    private com: CommonServices,
    private excel: ExcelExportService,
    private dateAdapter: DateAdapter<Date>,
    private branchState: OrgBranchStateManagement,
  ) {
    console.log(this.branchState)
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.branchState.fetchBranchList();
  }

  ngOnInit(): void {
    this.filterFormsLoad();
    this.getRouteIDS();
  }


  async getRouteIDS() {
    await this.getRouteData().catch((err) => console.log(err));
    this.listAPICall({
      transitMode: this.filterFormGrp.value.transitMode,
      tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime(),
      assigned: (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'true') ? true
        : (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'false') ? false : '',
      routeID: this.filterFormGrp.controls['transitMode']['value'] == 'Pickup' ? this.loginRouteID : this.logoutRouteID, //Login's ID
      empList: ['request'],
    });
  }

  getRouteData() {
    return new Promise((resolve, reject) => {
      this.api.transportMangerRouteList({}).then((res: any) => {
        if (res.status == 'success') {
          if (res.data.length > 0) {
            res.data.map((route) => {
              if (route.title == 'Login') {
                this.loginRouteID = route.routeID;
              }
              else if (route.title == 'Logout') {
                this.logoutRouteID = route.routeID;
              }
            });
            if (this.loginRouteID != '' && this.logoutRouteID != '') resolve(1);
            else reject({ 'message': 'failure' })
          }
        } else reject({ 'message': 'failure' });
      }).catch((err) => reject(err));
    })
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.uploadForm.controls[controlName].hasError(errorName);
  }

  filterFormsLoad() {
    this.filterFormGrp = new FormGroup({
      assigned: new FormControl('false',),
      search: new FormControl('',),
      tripDate: new FormControl(new Date,),
      transitMode: new FormControl('Pickup'),
      empList: new FormControl(['request']),
      selVehicle: new FormControl(''),
    })
  }
  public filterFormcheckError = (controlName: string, errorName: string) => {
    return this.filterFormGrp.controls[controlName].hasError(errorName);
  }

  listAPICall(obj: any) {
    let vehArr = [];
    this.filteredObj = obj;
    this.api.transportManagerRosterList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.changeTableView(obj['assigned']);
          this.tableData = res.data;
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i]['checked'] = this.checkBoxValue
            vehArr.push(this.tableData[i]['vehRegNo']);
          }
          vehArr.forEach((s: any) => { if (!this.getvehicles.includes(s)) this.getvehicles.push(s) });
          this.listOfEmpolyers = res['data'];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
      } else {
        this.tableData = [];
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log(err);
    })
    if (this.listOfEmpolyers.length > 0)
    {
      this.currentDate = false;
      this.showDownloadBtn=true
    }
  }

  assignedValues(e) {
    if (e == 'false') {
      this.listWiseDropdown = true;
    } else if (e == 'true') {
      this.listWiseDropdown = false;
    }
  }

  changeTableView(value: any) {
    if (value == true) {
      this.cols = this.assignCols;
      if(this.filteredObj.tripDate >= new Date(new Date().setHours(0,0,0,0)).getTime()){
        if((this.cols.findIndex((col)=>col.key=='action'))==-1){
          this.cols.push({
            key: 'action',
            display: 'Action',
            config: {
              isAction: true,
              actions: [
                { display: 'Remove', color: 'warn', icon: 'Delete' }
              ]
            }
          })
        }
      }
      else{
        this.cols.pop();
      }
      this.isEmpTable = true;
    } else if (value == false) {
      this.cols = this.unAssignedCols;
      this.isEmpTable = true;
    }
  }

  empListChange(event) {
    if (event && event.value && event.value.includes('employee')) {
      event.value = ['employee'];
      this.filterFormGrp.controls['empList'].patchValue(event.value);
    }
  }

  resetModalForm() {
    this.formSubmit = false;
    this.uploadForm.patchValue({
      date: [new Date().getTime()],
      files: '',
      type: 'overwrite',
      transitMode: 'Pickup',
      datePeriod: new FormControl('single'),     
      branch: new FormControl('Velachery'),
    });
    this.showErrMsg=false;
    this.fatErr=false;
  }

  onSubmit() {
    this.formSubmitted = true;
    this.showDownloadBtn = false;
    let isValid = this.filterFormGrp.valid;
    if (isValid) {
      let obj = {}
      if (this.filterFormGrp.value.search != '') obj['search'] = this.filterFormGrp.value.search;
      if (this.filterFormGrp.value.tripDate != '') obj['tripDate'] = new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime();
      if (this.filterFormGrp.value.transitMode != '') obj['transitMode'] = this.filterFormGrp.value.transitMode;
      
      if (this.filterFormGrp.value.assigned != '') {
        obj['assigned'] = (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'true') ? true
          : (this.filterFormGrp.value.assigned != '' && this.filterFormGrp.value.assigned == 'false') ? false : '';
      }
      if (this.filterFormGrp.value.assigned == 'false') {
        if (this.filterFormGrp.value.empList != '') {
          let empListArr = [];
          empListArr.push(this.filterFormGrp.value.empList)
          obj['empList'] = this.filterFormGrp.value.empList;
        }
      }
      obj['routeID'] = obj['transitMode']=='Pickup'?this.loginRouteID:this.logoutRouteID,
      this.listAPICall(obj)
      this.showDownloadBtn = true;
    }
  }

  async exportToExcel() {
    this.excelData={};
    let data = [];
    for (let i = 0; i < this.listOfEmpolyers.length; i++) {
      let item = this.listOfEmpolyers[i];
      try {
        let res = {
          value:  this.filteredObj['assigned'] ? [
            i + 1,
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            item.empName ? this.com.convertTitleCase(item.empName) : '---',
            item.gender ? item.gender : '---',
            item.shiftTime ? item.shiftTime : '---',
            (item.vehRegNo  && this.filteredObj['assigned']==true) ? String(item.vehRegNo).toUpperCase():'---',
            item.driverName?item.driverName:'---',
            item.eta ? item.eta : '---',
            item.address ? item.address : '---',
          ] :
          [ 
            i + 1,
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            item.empName ? this.com.convertTitleCase(item.empName) : '---',
            item.gender ? item.gender : '---',
            item.shiftTime ? item.shiftTime : '---',
            item.eta ? item.eta : '---',
            item.address ? item.address : '---',
          ],
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = this.filteredObj['assigned'] ? 'I' : 'G';
      let customizedData = [];
      let titleRow = {
        value: [this.filteredObj['assigned'] ? 'Assigned List' : 'Unassigned List'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);

      rowCount = this.filteredObj['assigned'] == false ? rowCount + 3 : rowCount + 2;

      let subtitleRow = {
        value: this.filteredObj['assigned'] == false ? [
          "Title :" + this.filterFormGrp.value.empList.map((item) => this.com.convertTitleCase(item)).join(',') + ' List' + "\n" +
          "Trip Date          : " + this.com.timestampToDate(new Date(this.filteredObj['tripDate']).getTime(), 'DMY') + "\n" +
          "Transit Mode    : " + this.filteredObj['transitMode'] + ""
        ] :
          [
            "Trip Date          : " + this.com.timestampToDate(new Date(this.filteredObj['tripDate']).getTime(), 'DMY') + "\n" +
            "Transit Mode    : " + this.filteredObj['transitMode'] + ""
          ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: this.filteredObj['assigned'] == false ? `A${(rowCount - 2) + ''}:${endCell + rowCount + ''}` : `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: this.filteredObj['assigned'] ? ['S.No.', 'Employee ID', 'Employee Name', 'Gender', 'Shift Time', 'Vehicle Reg No', 'Driver Name', 'ETA', 'Address'] :
          ['S.No.', 'Employee ID', 'Employee Name', 'Gender', 'Shift Time', 'ETA', 'Address'],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = this.filteredObj['assigned'] ? 'Assigned List' : 'Unassigned List'

      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: this.filteredObj['assigned'] ? [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 15 }, { colNo: 5, width: 15 }, { colNo: 6, width: 20 }, { colNo: 7, width: 25 }, { colNo: 8, width: 15 }, { colNo: 9, width: 50 }] :
            [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 15 }, { colNo: 5, width: 15 }, { colNo: 6, width: 20 }, { colNo: 7, width: 35 }, { colNo: 8, width: 15 }, { colNo: 9, width: 50 }],
        }
      };// excelInfo;

      this.downloadExlReport();

    }

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, this.filteredObj['assigned'] ? 'Assigned List' + new Date().getTime() : 'Unassigned List' + new Date().getTime() + '.xlsx');
  }

  onActionHandler(e: any) {
    if (e && e.action.display == 'Remove') {
      let obj = {
        routeID: e.data.routeID,
        employeeID: e.data.employeeID,
        tripDate: e.data.tripDate,
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to remove this employee!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove it!'
      }).then((result) => {
        if (result.isConfirmed) {
          console.log(obj);
        }
      });
    }
  }

  unassignEmp(removeObj) {
    this.api.transportManagerRosterUpdate(removeObj).then((res: any) => {
      if (res.status == 'success') {
        this.listAPICall(this.filteredObj);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  async resultExcelDownload(obj: any, successObj: any) {

    let rowCount = 2;
    let customizedData = [];
    let endCell = 'D';

    let titleRow = {
      value: [this.activeUpload['text'] == 'Login' ? 'Login-Upload' : 'Logout-Upload'],
      font: {
        name: 'Corbel', family: 4, size: 16, bold: true,
        color: { argb: 'FFFFFFFF' },
      },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      alignment: {
        cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '966462AF' },
        bgColor: { argb: 'FFF' }
      },
    }
    customizedData.push(titleRow);

    rowCount += 2;//4
    let subtitleRow = {
      value: [
        "Trip Date          : " + this.com.timestampToDate(new Date(this.filteredObj['tripDate']).getTime(), 'DMY') + "\n"
      ],
      font: { name: 'Corbel', family: 4, size: 12, },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
    }
    customizedData.push(subtitleRow);

    let resExcelData = {};
    let res = {}
    let data = [];

    let successData = [];
    let errorData = [];
    if(successObj && successObj.length>0){
      rowCount += 2;//6
      let successCountRow = {
      value:[
        "Success Counts          : " + this.successDataLen + "\n"
      ],
      font: { name: 'Corbel', family: 4, size: 12, },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }
      customizedData.push(successCountRow);
      
      rowCount+= 1;
      let successHeadersRow =
      {
        value: ['S.No.','Trip Date','Employee ID',]  ,
        mergeCells: `B7:${endCell + rowCount}`,
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      // Success MSG
      for(let i=0; i< successObj.length;i++){
        rowCount += 1;
        this.successEmpId = successObj[i] && successObj[i]['empInfo'] && successObj[i]['empInfo'][0] && successObj[i]['empInfo'][0]['empRefID'] ?successObj[i]['empInfo'][0]['empRefID'] : '';
          try {
            res = {
            value: [
              i + 1,
              this.com.timestampToDate(successObj[i]['tripDate'],'DMY','-'),
              this.successEmpId
            ],
            mergeCells: `B${rowCount}:C${rowCount}`,
          }
          successData.push(res);
        } catch (err) { console.log(err) }
      }
      customizedData.push(successHeadersRow, ...successData);
    }
    let errCount = 0;
    if(obj && Object.keys(obj).length>0){
      Object.keys(obj).map((date)=>{
        if(date && Object.keys(date).length>0){
          Object.keys(obj[date]).map((item, index) => {
            this.getRow = item;
            this.getNameOfErr = obj[date][item].join(', ')
            errCount+=1;
            try {
              res = {
              value:[
                errCount,
                date,
                this.getRow,
                this.getNameOfErr
              ]
            }
            errorData.push(res);
            } catch (err) { console.log(err) }
          })
        }
      })
    }

    if ((successData && errorData) || (successData.length > 0 && errorData.length > 0) || (successData.length > 0 || errorData.length > 0)) {

    rowCount += 1;//6
    let emptyCountRow = {
     value:[''],
     font: { name: 'Corbel', family: 4, size: 12, },
     mergeCells: `A${(rowCount) + ''}:${endCell + rowCount + ''}`,
    }
    customizedData.push(emptyCountRow);


      rowCount += 2;
      let errCountRow = {
        value: [
          "Error Counts          : " + this.errDataLen + "\n"
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }
      customizedData.push(errCountRow);

      rowCount = rowCount + 1;
      let errHeaderRow =
      {
        value: ['S.No.', 'Trip Date','Row No', 'Error'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(errHeaderRow, ...errorData);


      let excelSheetName = this.activeUpload['text'] == 'Login' ? 'Roster-Pickup' : 'Roster-Drop';

      if (resExcelData[excelSheetName] == undefined) { resExcelData[excelSheetName] = {}; }

      resExcelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 1, width: 15 }, { colNo: 2, width: 15 }, { colNo: 3, width: 15 }, { colNo: 4, width: 100 }]
        }
      };
      this.excel.generateExcel(resExcelData, this.activeUpload['text'] == 'Login' ? 'Roster-Pickup-' + new Date().getTime() : 'Roster-Drop-' + new Date().getTime() + '.xlsx');
    }

  }


  rosterExcelTemplate(){
    let dates = [];
    let tempExlData = {};
    if(this.uploadForm.value.date && this.uploadForm.value.date.length>0) dates = this.uploadForm.value.date;
    else dates = [ new Date().getTime() ]; 

    for(let d=0;d<dates.length;d++){

      let customizedData = [];
      let loopDate = new Date(dates[d]);
      let headerRow =
        {
          value: ['S.No', 'Employee ID','Employee Name','Employee Mobile','Gender','Shift Time','Area','Pickup ETA','Pickup Address','Pickup Vehicle','Drop ETA','Drop Address','Drop Vehicle','Branch','Trip sheet ID','Project'],
          font: { bold: true },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        }
        customizedData.push(headerRow);

        let valueRow = {
          value: [1,'Test568','XXXX','9874563210','M','07:00 - 19:00','Velachery','20:45:00','dfsgfgg','TN03KK7777 ABC 9898656532','20:45:00','dfgdfgsgdgfbhdgfbh','TN03KK7777 ABC 9898656532','','12233','Developement']
        }
        customizedData.push(valueRow);
  
        let excelSheetName = this.com.pad(loopDate.getDate())+'-'+this.com.pad(loopDate.getMonth()+1)+'-'+this.com.pad(loopDate.getFullYear());
        
        if(dates.length==1) excelSheetName = 'Roster'; 
        if (tempExlData[excelSheetName] == undefined) { tempExlData[excelSheetName] = {}; }
  
        tempExlData[excelSheetName] = {
          customizedData: customizedData,
          data: {
            columWith: [{ colNo: 2, width: 20 }, { colNo: 3, width: 25 }, { colNo: 4, width: 25 }, { colNo: 5, width: 10 }, { colNo: 6, width: 15 }, { colNo: 7, width: 25 }, { colNo: 8, width: 20 }, { colNo: 9, width: 25 },{ colNo: 10, width: 30 },{ colNo:11, width: 25 },{ colNo: 12, width: 25 },{ colNo: 13, width: 30 },{ colNo: 14, width: 25 },{ colNo: 15, width: 25 },{ colNo: 16, width: 25 }]
          }
        };
    }

      this.excel.generateExcel(tempExlData,'Roster-Excel-' + new Date().getTime() + '.xlsx');
    
  }
}
